import React from 'react';
import ReactDOM from 'react-dom';

import App from './App';

// [NOTE] - Can skip doing "window.LOG_LEVEL" during development
// window.LOG_LEVEL = 'DEBUG'

// [TODO-PWA] - Not needed until a machine is in the client
// import { inspect } from '@xstate/inspect';

// inspect({
//   // options
//   url: 'https://statecharts.io/inspect', // (default)
//   iframe: false, // open in new window
// });

ReactDOM.render(<App />, document.getElementById('app'));
